import { Language } from "../languages";

export const downloadsTranslations: Record<Language, any> = {
  es: {
    titlle: "PORTALES DE DESCARGA",
    windows: "DESCARGA PARA WINDOWS",
    mac: "DESCARGA PARA MAC",
  },
  en: {
    title: "DOWNLOAD PORTALS",
    windows: "DOWNLOAD FOR WINDOWS",
    mac: "DOWNLOAD FOR MAC",
  },
};
